import config from "../../config.js"
import { TwinClient as TwinClient0 } from "twin-client/src/client.js";

export class TreasuryClient extends TwinClient0 {

  constructor({ url, apiKey, token } = {}) {
    super({ url: config.backendUrl, apiKey });
    this.token = token;
    this.host = url;
  }

  static from(twinClient) {
    let { url, apiKey, token } = twinClient;
    return new TreasuryClient({ url, apiKey, token });
  }

  async request(config) { // make twin-client-js work with tokens
    let params = config.params || {};
    params = {
      ...params,
      host: this.host
    };

    let headers = config.headers || {};
    headers = {
      ...headers,
      ...this.token && { authorization: `${this.token.token_type} ${this.token.access_token }`}
    };

    return super.request({
      ...config,
      params,
      headers
    });
  }

  async getConfig() {
    return await this.request({
      method: "GET",
    });
  }

  async createSellRequest(data) {
    return await this.request({
      method: "POST",
      url: "/sell",
      data
    })
  }

  async getSellRequest(id) {
    if (id) {
      let sellRequest = await this.request({
        method: "GET",
        url: `/sell/${id}`
      });
      let comments = await this.getComments(id);
      return {...sellRequest, comments};
    }
    return await this.request({
      method: "GET",
      url: "/sell"
    });
  }

  async addPayoutInfo(sellRequestId, payoutInfo) {
    return await this.request({
      method: "POST",
      url: `/sell/${sellRequestId}/payout`,
      data: { payoutInfo }
    });
  }

  async getComments(sellRequestId) {
    return await this.request({
      method: "GET",
      url: `/sell/${sellRequestId}/comments`
    });
  }

  async addComment(sellRequestId, comment) {
    return await this.request({
      method: "POST",
      url: `/sell/${sellRequestId}/comments`,
      data: { comment }
    });
  }

  async createProfile(profile) {
    return this.request({
      method: "POST",
      url: `/profile`,
      data: profile
    });
  }

  async getProfile() {
    return await this.request({
      method: "GET",
      url: `/profile/${encodeURIComponent(this.host)}`,
    }).catch(e => {
      console.warn(e)
      return null;
      // HAAACK (sfertman): Make twin client:
      //    throw new TwinError("Not Found", data)
    });
  }

  async updateProfile(profile) {
    return this.request({
      method: "PUT",
      url: `/profile/${encodeURIComponent(this.host)}`,
      data: profile
    });
  }
}

